export const contactMethods = {
    Email: {
        value: 'email',
        label: 'Email'
    },
    SMS: {
        value: 'sms',
        label: 'SMS'
    }
};
export const validContactMethods = {
    Email: 'email',
    SMS: 'sms'
};
export const bookingMessageTypes = {
    Upcoming: {
        value: 'Upcoming',
        label: 'Scheduled',
        altLabel: 'Confirmation',
        getTitle: (bookingsEntityName) => `Scheduled ${bookingsEntityName}`,
        getSnackbarMessage: (bookingEntityName, bookingId) => `${bookingEntityName}  No. ${bookingId} has been successfully scheduled.`,
        isConfirmationTextOption: true
    },
    Affiliate: {
        value: 'Affiliate',
        label: 'Affiliate Scheduled',
        altLabel: 'Affiliate Confirmation',
        getTitle: (bookingsEntityName) => `Scheduled Affiliate ${bookingsEntityName}`,
        getSnackbarMessage: (bookingEntityName, bookingId) => `Affiliate ${bookingEntityName}  No. ${bookingId} has been successfully confirmed.`,
        isConfirmationTextOption: true
    },
    Rescheduled: {
        value: 'Rescheduled',
        label: 'Rescheduled',
        altLabel: 'Change of Schedule',
        getTitle: (bookingsEntityName) => `Rescheduled ${bookingsEntityName}`,
        getSnackbarMessage: (bookingEntityName, bookingId) => `${bookingEntityName}  No. ${bookingId} has been successfully rescheduled.`,
        isConfirmationTextOption: true
    },
    Canceled: {
        value: 'Canceled',
        label: 'Canceled',
        altLabel: 'Cancellation',
        getTitle: (bookingsEntityName) => `Cancelled ${bookingsEntityName}`,
        getSnackbarMessage: (bookingEntityName, bookingId) => `${bookingEntityName}  No. ${bookingId} has been successfully canceled.`,
        isConfirmationTextOption: true
    },
    DidNotAttend: {
        value: 'DidNotAttend',
        label: 'Did Not Attend',
        altLabel: 'Did Not Attend',
        getTitle: (bookingsEntityName) => `Did-Not-Attend ${bookingsEntityName}`,
        getSnackbarMessage: (bookingEntityName, bookingId) => `${bookingEntityName} No. ${bookingId} has been successfully updated as did-not-attend.`,
        isConfirmationTextOption: true
    },
    Reminder: {
        value: 'Reminder',
        label: 'Reminder',
        altLabel: 'Reminder',
        getTitle: (bookingsEntityName) => `Reminder for Scheduled ${bookingsEntityName}`,
        getSnackbarMessage: (bookingEntityName, bookingId) => `${bookingEntityName} No. ${bookingId} has been successfully updated as did-not-attend.`,
        isConfirmationTextOption: true
    },
    ChangeInService: {
        value: 'ChangeInService',
        label: 'Change In Service',
        altLabel: 'Change In Service',
        getTitle: (bookingsEntityName) => `Change In ${bookingsEntityName}'s Service`,
        getSnackbarMessage: (bookingEntityName, bookingId) => `The service for ${bookingEntityName}  No. ${bookingId} has been successfully changed.`,
        isConfirmationTextOption: false
    },
    ChangeInLocation: {
        value: 'ChangeInLocation',
        label: 'Change In Location',
        altLabel: 'Change In Location',
        getTitle: (bookingsEntityName) => `Change In ${bookingsEntityName}'s Location`,
        getSnackbarMessage: (bookingEntityName, bookingId) => `The location, as well as the specified date and time and other details for ${bookingEntityName}  No. ${bookingId} have been successfully changed.`,
        isConfirmationTextOption: false
    },
    MultipleChanges: {
        value: 'MultipleChanges',
        label: 'Multiple Changes',
        altLabel: 'Various Changes',
        getTitle: (bookingsEntityName) => `Major Changes In ${bookingsEntityName} Terms`,
        getSnackbarMessage: (bookingEntityName, bookingId) => `Various significant changes have been successfully applied to ${bookingEntityName}  No. ${bookingId} .`,
        isConfirmationTextOption: false
    }
};
export const COMMUNICATION_TEMPLATE_TYPE = {
    BOOKING: 'BOOKING',
    SURVEY: 'SURVEY',
};
export var COMMUNICATION_UNIT_KEY;
(function (COMMUNICATION_UNIT_KEY) {
    COMMUNICATION_UNIT_KEY["MINUTE"] = "MINUTE";
    COMMUNICATION_UNIT_KEY["HOUR"] = "HOUR";
    COMMUNICATION_UNIT_KEY["DAY"] = "DAY";
})(COMMUNICATION_UNIT_KEY || (COMMUNICATION_UNIT_KEY = {}));
export const communicationUnit = {
    [COMMUNICATION_UNIT_KEY.MINUTE]: {
        value: COMMUNICATION_UNIT_KEY.MINUTE,
        label: 'Minute(s)'
    },
    [COMMUNICATION_UNIT_KEY.HOUR]: {
        value: COMMUNICATION_UNIT_KEY.HOUR,
        label: 'Hour(s)'
    },
    [COMMUNICATION_UNIT_KEY.DAY]: {
        value: COMMUNICATION_UNIT_KEY.DAY,
        label: 'Day(s)'
    }
};
export var CONTACT_METHOD_KEY;
(function (CONTACT_METHOD_KEY) {
    CONTACT_METHOD_KEY["EMAIL"] = "EMAIL";
    CONTACT_METHOD_KEY["SMS"] = "SMS";
})(CONTACT_METHOD_KEY || (CONTACT_METHOD_KEY = {}));
export const CONTACT_METHOD = {
    [CONTACT_METHOD_KEY.EMAIL]: {
        value: CONTACT_METHOD_KEY.EMAIL,
        label: 'Email'
    },
    [CONTACT_METHOD_KEY.SMS]: {
        value: CONTACT_METHOD_KEY.SMS,
        label: 'SMS'
    }
};
export var COMMUNICATION_TYPE_KEY;
(function (COMMUNICATION_TYPE_KEY) {
    COMMUNICATION_TYPE_KEY["BOOKING"] = "BOOKING";
    COMMUNICATION_TYPE_KEY["SURVEY"] = "SURVEY";
})(COMMUNICATION_TYPE_KEY || (COMMUNICATION_TYPE_KEY = {}));
export var BOOKING_COMMUNICATION_SUBTYPE_KEY;
(function (BOOKING_COMMUNICATION_SUBTYPE_KEY) {
    BOOKING_COMMUNICATION_SUBTYPE_KEY["CONFIRMATION"] = "CONFIRMATION";
    BOOKING_COMMUNICATION_SUBTYPE_KEY["AFFILIATE_CONFIRMATION"] = "AFFILIATE_CONFIRMATION";
    BOOKING_COMMUNICATION_SUBTYPE_KEY["CANCELLED"] = "CANCELLED";
    BOOKING_COMMUNICATION_SUBTYPE_KEY["DID_NOT_ATTEND"] = "DID_NOT_ATTEND";
    BOOKING_COMMUNICATION_SUBTYPE_KEY["RESCHEDULED"] = "RESCHEDULED";
    BOOKING_COMMUNICATION_SUBTYPE_KEY["REMINDER"] = "REMINDER";
    BOOKING_COMMUNICATION_SUBTYPE_KEY["BNCL_REMINDER"] = "BNCL_REMINDER";
})(BOOKING_COMMUNICATION_SUBTYPE_KEY || (BOOKING_COMMUNICATION_SUBTYPE_KEY = {}));
export var SURVEY_COMMUNICATION_SUBTYPE_KEY;
(function (SURVEY_COMMUNICATION_SUBTYPE_KEY) {
    SURVEY_COMMUNICATION_SUBTYPE_KEY["SEND_WITH_LOGIN_LINK"] = "SEND_WITH_LOGIN_LINK";
    SURVEY_COMMUNICATION_SUBTYPE_KEY["SEND_WITH_PDF"] = "SEND_WITH_PDF";
    SURVEY_COMMUNICATION_SUBTYPE_KEY["PRE_SERVICE"] = "PRE_SERVICE";
    SURVEY_COMMUNICATION_SUBTYPE_KEY["POST_SERVICE"] = "POST_SERVICE";
})(SURVEY_COMMUNICATION_SUBTYPE_KEY || (SURVEY_COMMUNICATION_SUBTYPE_KEY = {}));
export var COMMUNICATION_REPLACEMENT_PLACEHOLDERS;
(function (COMMUNICATION_REPLACEMENT_PLACEHOLDERS) {
    COMMUNICATION_REPLACEMENT_PLACEHOLDERS["BOOKING_ID"] = "bookingId";
    COMMUNICATION_REPLACEMENT_PLACEHOLDERS["FIRST_NAME"] = "firstName";
    COMMUNICATION_REPLACEMENT_PLACEHOLDERS["LAST_NAME"] = "lastName";
    COMMUNICATION_REPLACEMENT_PLACEHOLDERS["APPOINTMENT_DATE"] = "appointmentDate";
    COMMUNICATION_REPLACEMENT_PLACEHOLDERS["APPOINTMENT_START"] = "appointmentStartTime";
    COMMUNICATION_REPLACEMENT_PLACEHOLDERS["APPOINTMENT_END"] = "appointmentEndTime";
    COMMUNICATION_REPLACEMENT_PLACEHOLDERS["PROVIDER_FIRST_NAME"] = "providerFirstName";
    COMMUNICATION_REPLACEMENT_PLACEHOLDERS["PROVIDER_LAST_NAME"] = "providerLastName";
    COMMUNICATION_REPLACEMENT_PLACEHOLDERS["SERVICE_NAME"] = "serviceName";
    COMMUNICATION_REPLACEMENT_PLACEHOLDERS["SERVICE_INSTRUCTIONS"] = "serviceInstructions";
    COMMUNICATION_REPLACEMENT_PLACEHOLDERS["LOCATION_NAME"] = "locationName";
    COMMUNICATION_REPLACEMENT_PLACEHOLDERS["LOCATION_ADDRESS"] = "locationAddress";
    COMMUNICATION_REPLACEMENT_PLACEHOLDERS["LOCATION_NOTES"] = "locationNotes";
    COMMUNICATION_REPLACEMENT_PLACEHOLDERS["SURVEY_LINK"] = "surveyLink";
    COMMUNICATION_REPLACEMENT_PLACEHOLDERS["LOGO"] = "logo";
    COMMUNICATION_REPLACEMENT_PLACEHOLDERS["PDF_URL"] = "pdfUrl";
    COMMUNICATION_REPLACEMENT_PLACEHOLDERS["AFFILIATE_NOTES"] = "affiliateNotes";
    COMMUNICATION_REPLACEMENT_PLACEHOLDERS["BOOKING_LINK"] = "bookingLink";
    COMMUNICATION_REPLACEMENT_PLACEHOLDERS["SURVEY_ID"] = "surveyId";
    COMMUNICATION_REPLACEMENT_PLACEHOLDERS["BOOKING_ENTITY_NAME"] = "bookingEntityName";
    COMMUNICATION_REPLACEMENT_PLACEHOLDERS["LOGIN_LINK"] = "loginLink";
    COMMUNICATION_REPLACEMENT_PLACEHOLDERS["PRE_SERVICE_SURVEY_LINKS"] = "preServiceSurveyLinks";
    COMMUNICATION_REPLACEMENT_PLACEHOLDERS["POST_SERVICE_SURVEY_LINKS"] = "postServiceSurveyLinks";
    COMMUNICATION_REPLACEMENT_PLACEHOLDERS["COMPANY_NAME"] = "companyName";
})(COMMUNICATION_REPLACEMENT_PLACEHOLDERS || (COMMUNICATION_REPLACEMENT_PLACEHOLDERS = {}));
export var COMMUNICATION_DIALOG_MODE;
(function (COMMUNICATION_DIALOG_MODE) {
    COMMUNICATION_DIALOG_MODE["CREATE"] = "CREATE";
    COMMUNICATION_DIALOG_MODE["EDIT"] = "EDIT";
})(COMMUNICATION_DIALOG_MODE || (COMMUNICATION_DIALOG_MODE = {}));
export const defaultCommunicationSubReplacement = {
    Required: [],
    Optional: [
        COMMUNICATION_REPLACEMENT_PLACEHOLDERS.BOOKING_ID,
        COMMUNICATION_REPLACEMENT_PLACEHOLDERS.FIRST_NAME,
        COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LAST_NAME,
        COMMUNICATION_REPLACEMENT_PLACEHOLDERS.APPOINTMENT_DATE,
        COMMUNICATION_REPLACEMENT_PLACEHOLDERS.APPOINTMENT_START,
        COMMUNICATION_REPLACEMENT_PLACEHOLDERS.APPOINTMENT_END,
        COMMUNICATION_REPLACEMENT_PLACEHOLDERS.PROVIDER_FIRST_NAME,
        COMMUNICATION_REPLACEMENT_PLACEHOLDERS.PROVIDER_LAST_NAME,
        COMMUNICATION_REPLACEMENT_PLACEHOLDERS.SERVICE_NAME,
        COMMUNICATION_REPLACEMENT_PLACEHOLDERS.SERVICE_INSTRUCTIONS,
        COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOCATION_NAME,
        COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOCATION_ADDRESS,
        COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOCATION_NOTES,
        COMMUNICATION_REPLACEMENT_PLACEHOLDERS.COMPANY_NAME,
    ]
};
export const communicationSubReplacement = {
    [BOOKING_COMMUNICATION_SUBTYPE_KEY.CONFIRMATION]: defaultCommunicationSubReplacement,
    [BOOKING_COMMUNICATION_SUBTYPE_KEY.AFFILIATE_CONFIRMATION]: defaultCommunicationSubReplacement,
    [BOOKING_COMMUNICATION_SUBTYPE_KEY.CANCELLED]: defaultCommunicationSubReplacement,
    [BOOKING_COMMUNICATION_SUBTYPE_KEY.DID_NOT_ATTEND]: defaultCommunicationSubReplacement,
    [BOOKING_COMMUNICATION_SUBTYPE_KEY.RESCHEDULED]: defaultCommunicationSubReplacement,
    [BOOKING_COMMUNICATION_SUBTYPE_KEY.REMINDER]: defaultCommunicationSubReplacement,
    [BOOKING_COMMUNICATION_SUBTYPE_KEY.BNCL_REMINDER]: {
        Required: [],
        Optional: [
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.BOOKING_LINK,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.FIRST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LAST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOCATION_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOGO,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.SERVICE_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.COMPANY_NAME,
        ],
    },
    [SURVEY_COMMUNICATION_SUBTYPE_KEY.SEND_WITH_LOGIN_LINK]: {
        Required: [],
        Optional: [
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.SURVEY_ID,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.FIRST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LAST_NAME,
        ]
    },
    [SURVEY_COMMUNICATION_SUBTYPE_KEY.SEND_WITH_PDF]: {
        Required: [],
        Optional: [
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.SURVEY_ID,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.FIRST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LAST_NAME,
        ]
    },
    [SURVEY_COMMUNICATION_SUBTYPE_KEY.PRE_SERVICE]: {
        Required: [
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.BOOKING_ENTITY_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.BOOKING_ID
        ],
        Optional: [],
        defaults: {
            emailSubject: `<div>
        <p>Pre-Service Survey for {bookingEntityName} No. {bookingId}</p>
      </div>`
        }
    },
    [SURVEY_COMMUNICATION_SUBTYPE_KEY.POST_SERVICE]: {
        Required: [
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.BOOKING_ENTITY_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.BOOKING_ID
        ],
        Optional: [],
        defaults: {
            emailSubject: `<div>
        <p>Post-Service Survey for {bookingEntityName} No. {bookingId}</p>
      </div>`
        }
    }
};
export const communicationBodyReplacement = {
    [BOOKING_COMMUNICATION_SUBTYPE_KEY.AFFILIATE_CONFIRMATION]: {
        Required: [],
        Optional: [
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.BOOKING_ID,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.FIRST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LAST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.APPOINTMENT_DATE,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.APPOINTMENT_START,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.APPOINTMENT_END,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOCATION_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.SURVEY_LINK,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.SERVICE_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.SERVICE_INSTRUCTIONS,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOGO,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.PDF_URL,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.AFFILIATE_NOTES,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.COMPANY_NAME
        ],
        defaults: {
            emailBody: `<div>
          <p>Hi {firstName} {lastName},</p>
          <p>Your booking has been requested, we will be in contact to confirm your details.</p>
          <p>BookingID: {bookingId}</p>
          <p>Date: {appointmentDate}</p>
          <p>Time: {appointmentStartTime}</p>
          <p>Service: {serviceName}</p>
          <p>{serviceInstructions}</p>
          <p>Your appointment is at {locationName}.</p>
          <p>Please click the link below to answer these important questions before your appointment.</p>
          <p>{surveyLink}</p>
          <p>{affiliateNotes}</p>
        </div>`,
            smsBody: `Hi {firstName} {lastName}, your booking has been requested.\n\nBookingID: {bookingId}\nDate: {appointmentDate}\nTime: {appointmentStartTime}\nService: {serviceName}\n{serviceInstructions}\n\nPlease click the link below to answer these important questions before your appointment:\n{surveyLink}\n\n{affiliateNotes}`
        }
    },
    [BOOKING_COMMUNICATION_SUBTYPE_KEY.CONFIRMATION]: {
        Required: [
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.APPOINTMENT_DATE,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.APPOINTMENT_START
        ],
        Optional: [
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.BOOKING_ID,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.FIRST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LAST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.PROVIDER_FIRST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.PROVIDER_LAST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.APPOINTMENT_END,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOCATION_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOCATION_ADDRESS,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOCATION_NOTES,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.SERVICE_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.SERVICE_INSTRUCTIONS,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.SURVEY_LINK,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOGO,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.PDF_URL,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.COMPANY_NAME
        ],
        defaults: {
            emailBody: `<div>
          <p>Hi {firstName} {lastName},</p>
          <p>Here are your <strong>Appointment Details:</strong></p>
          <p>BookingID: {bookingId}</p>
          <p>Date: {appointmentDate}</p>
          <p>Time: {appointmentStartTime}</p>
          <p>Service Provider: {providerFirstName} {providerLastName}</p>
          <p>Service: {serviceName}</p>
          <p>{serviceInstructions}</p>
          <p>Your appointment is at {locationName} {locationAddress}.</p>
          <p>{locationNotes}</p>
          <p>Please click the link below to answer these important questions before your appointment.</p>
          <p>{surveyLink}</p>
        </div>`,
            smsBody: `Hi {firstName} {lastName},\n\nHere are your Appointment Details:\nBookingID: {bookingId}\nDate: {appointmentDate}\nTime: {appointmentStartTime}\nService Provider: {providerFirstName} {providerLastName}\nService: {serviceName}\n{serviceInstructions}\n\nYour appointment is at {locationName} {locationAddress}.\n{locationNotes}\n\nPlease click the link below to answer these important questions before your appointment:\n{surveyLink}`
        }
    },
    [BOOKING_COMMUNICATION_SUBTYPE_KEY.CANCELLED]: {
        Required: [
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.APPOINTMENT_DATE,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.APPOINTMENT_START
        ],
        Optional: [
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.BOOKING_ID,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.FIRST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LAST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.PROVIDER_FIRST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.PROVIDER_LAST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.APPOINTMENT_END,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOCATION_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOCATION_ADDRESS,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOCATION_NOTES,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.SERVICE_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.SERVICE_INSTRUCTIONS,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.SURVEY_LINK,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOGO,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.PDF_URL,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.COMPANY_NAME,
        ],
        defaults: {
            emailBody: `<div>
          <p>Hi {firstName} {lastName},</p>
          <p>We regret to inform you that your appointment has been canceled. Here are the details:</p>
          <p><strong>Appointment Details:</strong></p>
          <p>Booking ID: {bookingId}</p>
          <p>Date: {appointmentDate}</p>
          <p>Time: {appointmentStartTime}</p>
          <p>Service Provider: {providerFirstName} {providerLastName}</p>
          <p>Service: {serviceName}</p>
          <p>{serviceInstructions}</p>
          <p>Your appointment was originally scheduled at {locationName} {locationAddress}.</p>
          <p>{locationNotes}</p>
          <p>If you have any questions or concerns, please contact us.</p>
        </div>`,
            smsBody: `Hi {firstName} {lastName},\n\nWe regret to inform you that your appointment has been canceled.\n\nAppointment Details:\nBooking ID: {bookingId}\nDate: {appointmentDate}\nTime: {appointmentStartTime}\nService Provider: {providerFirstName} {providerLastName}\nService: {serviceName}\n{serviceInstructions}\n\nYour appointment was originally scheduled at {locationName} {locationAddress}.\n{locationNotes}`
        }
    },
    [BOOKING_COMMUNICATION_SUBTYPE_KEY.DID_NOT_ATTEND]: {
        Required: [
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.APPOINTMENT_DATE,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.APPOINTMENT_START
        ],
        Optional: [
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.BOOKING_ID,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.FIRST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LAST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.PROVIDER_FIRST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.PROVIDER_LAST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.APPOINTMENT_END,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOCATION_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOCATION_ADDRESS,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOCATION_NOTES,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.SERVICE_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.SERVICE_INSTRUCTIONS,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.SURVEY_LINK,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOGO,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.PDF_URL,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.COMPANY_NAME,
        ],
        defaults: {
            emailBody: `<div>
          <p>Hi {firstName} {lastName},</p>
          <p>This is to inform you that you have failed to attend a scheduled booking. Here are the details:</p>
          <p><strong>Appointment Details:</strong></p>
          <p>Booking ID: {bookingId}</p>
          <p>Date: {appointmentDate}</p>
          <p>Time: {appointmentStartTime}</p>
          <p>Service Provider: {providerFirstName} {providerLastName}</p>
          <p>Service: {serviceName}</p>
          <p>{serviceInstructions}</p>
          <p>Your appointment was originally scheduled at {locationName} {locationAddress}.</p>
          <p>{locationNotes}</p>
        </div>`,
            smsBody: `Hi {firstName} {lastName},\n\nThis is to inform you that you have failed to attend a scheduled booking.\n\nAppointment Details:\nBooking ID: {bookingId}\nDate: {appointmentDate}\nTime: {appointmentStartTime}\nService Provider: {providerFirstName} {providerLastName}\nService: {serviceName}\n{serviceInstructions}\n\nYour appointment was originally scheduled at {locationName} {locationAddress}.\n{locationNotes}`
        }
    },
    [BOOKING_COMMUNICATION_SUBTYPE_KEY.RESCHEDULED]: {
        Required: [
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.APPOINTMENT_DATE,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.APPOINTMENT_START
        ],
        Optional: [
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.BOOKING_ID,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.FIRST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LAST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.PROVIDER_FIRST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.PROVIDER_LAST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.APPOINTMENT_END,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOCATION_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOCATION_ADDRESS,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOCATION_NOTES,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.SERVICE_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.SERVICE_INSTRUCTIONS,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.SURVEY_LINK,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOGO,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.PDF_URL,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.COMPANY_NAME,
        ],
        defaults: {
            emailBody: `<div>
          <p>Hi {firstName} {lastName},</p>
          <p>This is to inform you about some changes to your scheduled booking. Below are the updated details:</p>
          <p><strong>Appointment Details:</strong></p>
          <p>Booking ID: {bookingId}</p>
          <p>Date: {appointmentDate}</p>
          <p>Time: {appointmentStartTime}</p>
          <p>Service Provider: {providerFirstName} {providerLastName}</p>
          <p>Service: {serviceName}</p>
          <p>{serviceInstructions}</p>
          <p>Your appointment is scheduled at {locationName} {locationAddress}.</p>
          <p>{locationNotes}</p>
        </div>`,
            smsBody: `Hi {firstName} {lastName},\n\nThis is to inform you about some changes to your scheduled booking.\n\nAppointment Details:\nBooking ID: {bookingId}\nDate: {appointmentDate}\nTime: {appointmentStartTime}\nService Provider: {providerFirstName} {providerLastName}\nService: {serviceName}\n{serviceInstructions}\n\nYour appointment is scheduled at {locationName} {locationAddress}.\n{locationNotes}`
        }
    },
    [BOOKING_COMMUNICATION_SUBTYPE_KEY.REMINDER]: {
        Required: [
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.APPOINTMENT_DATE,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.APPOINTMENT_START
        ],
        Optional: [
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.BOOKING_ID,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.FIRST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LAST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.PROVIDER_FIRST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.PROVIDER_LAST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.APPOINTMENT_END,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOCATION_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOCATION_ADDRESS,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOCATION_NOTES,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.SERVICE_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.SERVICE_INSTRUCTIONS,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.SURVEY_LINK,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOGO,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.PDF_URL,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.COMPANY_NAME,
        ],
        defaults: {
            emailBody: `<div>
          <p>Hi {firstName} {lastName},</p>
          <p>This is a gentle reminder for your scheduled booking. Here are the details:</p>
          <p><strong>Appointment Details:</strong></p>
          <p>Booking ID: {bookingId}</p>
          <p>Date: {appointmentDate}</p>
          <p>Time: {appointmentStartTime}</p>
          <p>Service Provider: {providerFirstName} {providerLastName}</p>
          <p>Service: {serviceName}</p>
          <p>{serviceInstructions}</p>
          <p>Your appointment is scheduled at {locationName} {locationAddress}.</p>
          <p>{locationNotes}</p>
        </div>`,
            smsBody: `Hi {firstName} {lastName},\n\nThis is a gentle reminder for your scheduled booking.\n\nAppointment Details:\nBooking ID: {bookingId}\nDate: {appointmentDate}\nTime: {appointmentStartTime}\nService Provider: {providerFirstName} {providerLastName}\nService: {serviceName}\n{serviceInstructions}\n\nYour appointment is scheduled at {locationName} {locationAddress}.\n{locationNotes}`
        }
    },
    [BOOKING_COMMUNICATION_SUBTYPE_KEY.BNCL_REMINDER]: {
        Required: [],
        Optional: [
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.BOOKING_LINK,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.FIRST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LAST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOCATION_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOGO,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.SERVICE_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.COMPANY_NAME,
        ],
        defaults: {
            emailBody: `<div>
          <p>Hi {firstName},</p>
          <p>Please confirm your availability for your booking at {locationName}.</p>
          <p>Click the link below to finalise</p>
          <p>{bookingLink=Confirm here}</p>
        </div>`,
            smsBody: `Hi {firstName}, please confirm your availability for your booking at {locationName}. Confirm here: {bookingLink}`
        }
    },
    [SURVEY_COMMUNICATION_SUBTYPE_KEY.SEND_WITH_LOGIN_LINK]: {
        Required: [],
        Optional: [
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.SURVEY_ID,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.FIRST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LAST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOGIN_LINK,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOGO
        ]
    },
    [SURVEY_COMMUNICATION_SUBTYPE_KEY.SEND_WITH_PDF]: {
        Required: [],
        Optional: [
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.SURVEY_ID,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.FIRST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LAST_NAME,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.LOGO
        ]
    },
    [SURVEY_COMMUNICATION_SUBTYPE_KEY.PRE_SERVICE]: {
        Required: [
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.PRE_SERVICE_SURVEY_LINKS,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.FIRST_NAME,
        ],
        Optional: [],
        defaults: {
            emailBody: `<div>
          <p>Hi {firstName},</p>
          <p>To help us prepare for your upcoming appointment, please complete the pre-service survey.</p>
          <p>Click the link below to get started:</p>
          <p>{preServiceSurveyLinks}</p>
        </div>`,
            smsBody: `
        Hi {firstName}, to help us prepare for your upcoming appointment, please complete the pre-service survey: {preServiceSurveyLinks}
      `
        }
    },
    [SURVEY_COMMUNICATION_SUBTYPE_KEY.POST_SERVICE]: {
        Required: [
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.POST_SERVICE_SURVEY_LINKS,
            COMMUNICATION_REPLACEMENT_PLACEHOLDERS.FIRST_NAME
        ],
        Optional: [],
        defaults: {
            emailBody: `<div>
          <p>Hi {firstName},</p>
          <p>We’d love your feedback on your recent appointment. Please take a moment to complete our short post-service survey.</p>
          <p>Click the link below to get started:</p>
          <p>{postServiceSurveyLinks}</p>
        </div>`,
            smsBody: `
        Hi {firstName}, we’d love your feedback on your recent appointment. Please take a moment to complete our short post-service survey: {postServiceSurveyLinks}
      `
        }
    }
};
export var COMMUNICATION_TEMPLATE_PART_KEY;
(function (COMMUNICATION_TEMPLATE_PART_KEY) {
    COMMUNICATION_TEMPLATE_PART_KEY["EMAIL_SUBJECT"] = "EMAIL_SUBJECT";
    COMMUNICATION_TEMPLATE_PART_KEY["EMAIL_BODY"] = "EMAIL_BODY";
    COMMUNICATION_TEMPLATE_PART_KEY["SMS_BODY"] = "SMS_BODY";
})(COMMUNICATION_TEMPLATE_PART_KEY || (COMMUNICATION_TEMPLATE_PART_KEY = {}));
export const communicationTemplates = {
    [COMMUNICATION_TYPE_KEY.BOOKING]: {
        subtypes: {
            [BOOKING_COMMUNICATION_SUBTYPE_KEY.CONFIRMATION]: {
                subjectReplacement: communicationSubReplacement[BOOKING_COMMUNICATION_SUBTYPE_KEY.CONFIRMATION],
                bodyReplacement: communicationBodyReplacement[BOOKING_COMMUNICATION_SUBTYPE_KEY.CONFIRMATION],
                label: 'Confirmation',
                allowSchedule: false,
                allowDelete: false,
                allowEnableDisable: false,
                allowUserCreation: false,
            },
            [BOOKING_COMMUNICATION_SUBTYPE_KEY.AFFILIATE_CONFIRMATION]: {
                subjectReplacement: communicationSubReplacement[BOOKING_COMMUNICATION_SUBTYPE_KEY.AFFILIATE_CONFIRMATION],
                bodyReplacement: communicationBodyReplacement[BOOKING_COMMUNICATION_SUBTYPE_KEY.AFFILIATE_CONFIRMATION],
                label: 'Affiliate Confirmation',
                allowSchedule: false,
                allowDelete: false,
                allowEnableDisable: false,
                allowUserCreation: false,
            },
            [BOOKING_COMMUNICATION_SUBTYPE_KEY.CANCELLED]: {
                subjectReplacement: communicationSubReplacement[BOOKING_COMMUNICATION_SUBTYPE_KEY.CANCELLED],
                bodyReplacement: communicationBodyReplacement[BOOKING_COMMUNICATION_SUBTYPE_KEY.CANCELLED],
                label: 'Cancelled',
                allowSchedule: false,
                allowDelete: false,
                allowEnableDisable: false,
                allowUserCreation: false,
            },
            [BOOKING_COMMUNICATION_SUBTYPE_KEY.DID_NOT_ATTEND]: {
                subjectReplacement: communicationSubReplacement[BOOKING_COMMUNICATION_SUBTYPE_KEY.DID_NOT_ATTEND],
                bodyReplacement: communicationBodyReplacement[BOOKING_COMMUNICATION_SUBTYPE_KEY.DID_NOT_ATTEND],
                label: 'Did Not Attend',
                allowSchedule: false,
                allowDelete: false,
                allowEnableDisable: false,
                allowUserCreation: false,
            },
            [BOOKING_COMMUNICATION_SUBTYPE_KEY.RESCHEDULED]: {
                subjectReplacement: communicationSubReplacement[BOOKING_COMMUNICATION_SUBTYPE_KEY.RESCHEDULED],
                bodyReplacement: communicationBodyReplacement[BOOKING_COMMUNICATION_SUBTYPE_KEY.RESCHEDULED],
                label: 'Rescheduled',
                allowSchedule: false,
                allowDelete: false,
                allowEnableDisable: false,
                allowUserCreation: false,
            },
            [BOOKING_COMMUNICATION_SUBTYPE_KEY.REMINDER]: {
                subjectReplacement: communicationSubReplacement[BOOKING_COMMUNICATION_SUBTYPE_KEY.REMINDER],
                bodyReplacement: communicationBodyReplacement[BOOKING_COMMUNICATION_SUBTYPE_KEY.REMINDER],
                label: 'Reminder',
                allowSchedule: false,
                allowDelete: false,
                allowEnableDisable: false,
                allowUserCreation: false,
            },
            [BOOKING_COMMUNICATION_SUBTYPE_KEY.BNCL_REMINDER]: {
                subjectReplacement: communicationSubReplacement[BOOKING_COMMUNICATION_SUBTYPE_KEY.BNCL_REMINDER],
                bodyReplacement: communicationBodyReplacement[BOOKING_COMMUNICATION_SUBTYPE_KEY.BNCL_REMINDER],
                label: 'Book Now, Confirm Later Reminder',
                allowSchedule: true,
                allowDelete: true,
                allowEnableDisable: true,
                allowUserCreation: true,
                defaultValue: {
                    name: 'Book Now, Confirm Later Reminder',
                    type: COMMUNICATION_TYPE_KEY.BOOKING,
                    subtype: BOOKING_COMMUNICATION_SUBTYPE_KEY.BNCL_REMINDER,
                    contactMethod: CONTACT_METHOD_KEY.EMAIL,
                    messageSubject: "We're still waiting for you to confirm your ideal appointment time",
                    messageBody: "<p>Hi {firstName},</p><p>Please confirm your availability for your booking at {locationName}.</p><p>Click the link below to finalise</p><p>{bookingLink=Confirm here}</p>",
                    sendTimeOffset: 2,
                    sendTimeUnit: COMMUNICATION_UNIT_KEY.DAY,
                    enabled: true
                }
            }
        }
    },
    [COMMUNICATION_TYPE_KEY.SURVEY]: {
        subtypes: {
            [SURVEY_COMMUNICATION_SUBTYPE_KEY.SEND_WITH_LOGIN_LINK]: {
                subjectReplacement: communicationSubReplacement[SURVEY_COMMUNICATION_SUBTYPE_KEY.SEND_WITH_LOGIN_LINK],
                bodyReplacement: communicationBodyReplacement[SURVEY_COMMUNICATION_SUBTYPE_KEY.SEND_WITH_LOGIN_LINK],
                label: 'Send With Login Link',
                allowSchedule: false,
                allowDelete: false,
                allowEnableDisable: false,
                allowUserCreation: false,
            },
            [SURVEY_COMMUNICATION_SUBTYPE_KEY.SEND_WITH_PDF]: {
                subjectReplacement: communicationSubReplacement[SURVEY_COMMUNICATION_SUBTYPE_KEY.SEND_WITH_PDF],
                bodyReplacement: communicationBodyReplacement[SURVEY_COMMUNICATION_SUBTYPE_KEY.SEND_WITH_PDF],
                label: 'Send With PDF',
                allowSchedule: false,
                allowDelete: false,
                allowEnableDisable: false,
                allowUserCreation: false,
            },
            [SURVEY_COMMUNICATION_SUBTYPE_KEY.PRE_SERVICE]: {
                subjectReplacement: communicationSubReplacement[SURVEY_COMMUNICATION_SUBTYPE_KEY.PRE_SERVICE],
                bodyReplacement: communicationBodyReplacement[SURVEY_COMMUNICATION_SUBTYPE_KEY.PRE_SERVICE],
                label: 'Pre-Service',
                allowSchedule: true,
                allowDelete: false,
                allowEnableDisable: true,
                allowUserCreation: false,
            },
            [SURVEY_COMMUNICATION_SUBTYPE_KEY.POST_SERVICE]: {
                subjectReplacement: communicationSubReplacement[SURVEY_COMMUNICATION_SUBTYPE_KEY.POST_SERVICE],
                bodyReplacement: communicationBodyReplacement[SURVEY_COMMUNICATION_SUBTYPE_KEY.POST_SERVICE],
                label: 'Post-Service',
                allowSchedule: true,
                allowDelete: false,
                allowEnableDisable: true,
                allowUserCreation: false,
            }
        }
    }
};
//# sourceMappingURL=communications.js.map